// extracted by mini-css-extract-plugin
export default {"active":"DimensionList_active__DTRms","dimensionItem":"DimensionList_dimensionItem__o+TKi","MuiListItemButton-root":"DimensionList_MuiListItemButton-root__dib+I"};